import { ArdoqId } from '@ardoq/api-types';
import { workspaceInterface } from '@ardoq/workspace-interface';
import { ComponentsData } from '../types';
import { composeComponentsIds } from './composeComponentsIds';
import { componentInterface } from '@ardoq/component-interface';

export const getTargetData = (
  workspaceId: ArdoqId | null,
  limit = Infinity
): ComponentsData => {
  if (!workspaceId) {
    return { componentIds: [], workspaceName: null, allComponentsCount: 0 };
  }

  const workspaceName = workspaceInterface.getWorkspaceName(workspaceId);
  const hierarchy = componentInterface.getComponentsHierarchyByWorkspaceIds([
    workspaceId,
  ]);
  const workspaceNode = hierarchy[workspaceId];
  if (!workspaceNode) {
    return { componentIds: [], workspaceName, allComponentsCount: 0 };
  }
  const allComponentsCount =
    Object.keys(hierarchy).length - [hierarchy.root, workspaceNode].length;
  const isLimitingComponents = allComponentsCount > limit;

  const componentIds = composeComponentsIds({
    hierarchy,
    children: workspaceNode.children || [],
    limit: isLimitingComponents ? limit : Infinity,
  });

  return { componentIds, workspaceName, allComponentsCount };
};
